import React from 'react';
import SVGIcon from '../components/SVGIcon';
import styles from './SettingsNavItem.module.scss';
import NavLink from '../utils/router/NavLink';

interface SettingsNavItemProps {
  children: React.ReactNode;
  icon: React.ReactNode;
  to: string;
  onlyActiveOnIndex?: boolean;
}

const SettingsNavItem = ({
  children,
  icon,
  to,
  onlyActiveOnIndex,
}: SettingsNavItemProps) => (
  <NavLink
    to={to}
    className={styles.item}
    activeClassName={styles.active}
    onlyActiveOnIndex={onlyActiveOnIndex}
  >
    <div className={styles.icon}>
      {typeof icon === 'string' ? <SVGIcon size={16}>{icon}</SVGIcon> : icon}
    </div>
    {children}
  </NavLink>
);

export default SettingsNavItem;
